import { type ApiCompanySummary } from "../../../models/api/admin/company";
import DepartmentDropdown from "./DepartmentDropdown";
import CompanyDropdown from "./CompanyDropdown";
import { type ApiDepartmentSummary } from "../../../models/api/admin/department";

export type CompanyDepartmentSelectorProps = {
    currentDepartment: ApiDepartmentSummary | null;
    handleDepartmentChange: (department: ApiDepartmentSummary | null) => void;
    selectedCompany: ApiCompanySummary | null;
    handleCompanyChange: (company: ApiCompanySummary | null) => void;
    containerStyles?: string;
    showLabels?: boolean;
};

const CompanyDepartmentSelector: React.FC<CompanyDepartmentSelectorProps> = ({
    currentDepartment,
    handleDepartmentChange,
    selectedCompany,
    handleCompanyChange,
    containerStyles,
    showLabels,
}) => {
    return (
        <div
            className={
                containerStyles ??
                "flex w-full flex-col gap-4 md:w-fit md:flex-row"
            }
        >
            <CompanyDropdown
                handleCompanyChange={handleCompanyChange}
                selectedCompany={selectedCompany}
                showLabels={showLabels}
            />
            {selectedCompany && (
                <DepartmentDropdown
                    companyId={selectedCompany?.companyId}
                    currentDepartment={currentDepartment}
                    handleDepartmentChange={handleDepartmentChange}
                    showLabel={showLabels}
                />
            )}
        </div>
    );
};

export default CompanyDepartmentSelector;
